import React, {useEffect, useState} from "react";
import {FlexColumnWidth100} from "../../../components/ui/Content";
import {Body1, Body1PointerLink} from "../../../components/Font";
import {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import {InputElement} from "../../../ui/Input/Input";
import {cleanError, clearCountdown, RetryMailCode, SubmitMailCode} from "../slice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import moment from "moment";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../ui/Loader/MiniLoader";
import {RegisterInputContainer} from "../../../components/ui/InputSearch";
import {RegisterStepEnum} from "../../../enum/auth";

export const EnterMailCode = () => {

    const Theme = useTheme()
    const [countdown, setCountdown] = useState(0)
    const {t} = useTranslation();
    const [code, setCode] = useState('')
    const dispatch = useAppDispatch()
    const {registerStep, mail, codePending, error, retryAfter} = useAppSelector(state => state.auth)

    useEffect(() => {
        const input = document.querySelector('.registerCodeInput') as HTMLInputElement
        if (input) {
            input.focus()
        }
    }, [])

    useEffect(() => {
        if (retryAfter && (registerStep===RegisterStepEnum.MailSubmit || registerStep===RegisterStepEnum.MailSent)) {
            setCountdown(retryAfter)
        }
    }, [registerStep, retryAfter])

    useEffect(() => {
        const count = () => {
            if (countdown > 0) {
                setCountdown(countdown - 1)
            } else {
                dispatch(clearCountdown())
            }
        }

        const timeout = setTimeout(count, 1000)

        return () => clearTimeout(timeout)
    }, [countdown])

    const submit = () => {

        if (mail) {

            dispatch(SubmitMailCode({
                email: mail,
                code: code
            }))
            // dispatch(fakeEmailCodeSubmit())
        }

    }

    useEffect(() => {
        if (code && code.length === 6) {
            submit()
        }
    },[code])

    return <FlexColumnWidth100>
        <RegisterInputContainer>
            <InputElement
                style={{ marginTop: '10px' }}
                className={'registerCodeInput'}
                format={'###-###'}
                error={error['code']}
                mask={'_'}
                onChange={value => {
                    setCode(value)
                    if (error['code']) {
                        dispatch(cleanError('code'))
                    }
                }}
                value={code}
                onKeyDown={(key) => {
                    if ((key === 'Enter' || key === 'NumpadEnter') && code.length > 0) {
                        submit()
                    }
                }}
                placeholder={t('auth.enterMailCode')}/>
        </RegisterInputContainer>

        {countdown <= 0
            ? <>{codePending
                ? <LoaderContainer>
                    <MiniLoader color={Theme.color.indicator} size={LoaderEnum.small}/>
                </LoaderContainer>
                :
                    <Body1PointerLink style={{ fontSize:'12px'}} onClick={() => {
                        if (mail) {dispatch(RetryMailCode({
                            email: mail
                        }))
                        }
                    }}>
                        {t('auth.retryCode')}
                    </Body1PointerLink>
                }</>
            :
                <Body1 color={Theme.color.secondary}>
                    {t('auth.retryCodeAfter')}{moment.utc(countdown * 1000).format('mm:ss')}
                </Body1>
            }

        {/*{!isFetching && registerStep === RegisterStepEnum.MailSent &&*/}
        {/*<ButtonPrimary disabled={code.length !== 6} onClick={submit}>*/}
        {/*    {t('auth.continue')}*/}
        {/*</ButtonPrimary>}*/}
    </FlexColumnWidth100>
}
